import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useTranslation, Trans } from 'react-i18next';
import { SignupForm } from '../components/SignupForm';
import Nav from '../../IDE/components/Header/Nav';
import { RootPage } from '../../../components/RootPage';

export function SignupView() {
  const { t } = useTranslation();
  // While the account is being created, the SignupForm shows a status message in place of the form;
  // hide the title and navigation links too so only that message remains on screen.
  const [creating, setCreating] = useState(false);
  return (
    <RootPage>
      <Nav layout="dashboard" />
      <main className="form-container">
        <Helmet>
          <title>{t('SignupView.Title')}</title>
        </Helmet>
        <div className="form-container__content">
          {!creating && (
            <h2 className="form-container__title">
              {t('SignupView.Description')}
            </h2>
          )}
          <SignupForm onCreatingChange={setCreating} />
          {!creating && (
            <>
              <p className="form__navigation-options">
                <Trans
                  i18nKey="SignupView.Warning"
                  components={[
                    <Link to="/terms-of-use">Terms of use</Link>,
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  ]}
                />
              </p>
              <p className="form__navigation-options">
                {t('SignupView.AlreadyHave')}{' '}
                <Link className="form__login-button" to="/login">
                  {t('SignupView.Login')}
                </Link>
              </p>
            </>
          )}
        </div>
      </main>
    </RootPage>
  );
}
